import { c as _c } from "react/compiler-runtime";
import type { ReactElement } from "react";
import { ForhandsvarselComponent } from "@/components/view/ForhandsvarselComponent";
import { IkkeOppfyltComponent } from "@/components/view/ikkeOppfylt/IkkeOppfyltComponent";
import { MottattVurderingComponent } from "@/components/view/MottattVurderingComponent";
import { UnderBehandlingComponent } from "@/components/view/UnderBehandlingComponent";
import type { AktivitetskravViewItem } from "@/components/view/viewUtils";
interface Props {
  viewItem?: AktivitetskravViewItem | null;
}
export const Vurdering = t0 => {
  const $ = _c(8);
  const {
    viewItem
  } = t0;
  if (!viewItem) {
    return null;
  }
  switch (viewItem.type) {
    case "FORHANDSVARSEL":
      {
        let t1;
        if ($[0] !== viewItem.vurdering) {
          t1 = <ForhandsvarselComponent vurdering={viewItem.vurdering} />;
          $[0] = viewItem.vurdering;
          $[1] = t1;
        } else {
          t1 = $[1];
        }
        return t1;
      }
    case "MOTTATT_VURDERING":
      {
        let t1;
        if ($[2] !== viewItem.vurdering) {
          t1 = <MottattVurderingComponent vurdering={viewItem.vurdering} />;
          $[2] = viewItem.vurdering;
          $[3] = t1;
        } else {
          t1 = $[3];
        }
        return t1;
      }
    case "UNDER_BEHANDLING":
      {
        let t1;
        if ($[4] !== viewItem.vurdering) {
          t1 = <UnderBehandlingComponent vurdering={viewItem.vurdering} />;
          $[4] = viewItem.vurdering;
          $[5] = t1;
        } else {
          t1 = $[5];
        }
        return t1;
      }
    case "INNSTILLING_OM_STANS":
      {
        let t1;
        if ($[6] !== viewItem.vurdering) {
          t1 = <IkkeOppfyltComponent vurdering={viewItem.vurdering} />;
          $[6] = viewItem.vurdering;
          $[7] = t1;
        } else {
          t1 = $[7];
        }
        return t1;
      }
    default:
      {
        return null;
      }
  }
};